'use client';

import useTrackEvent from '@/application/write/analytics/useTrackEvent';
import BugBountyGraphic from '@/assets/bugbounty.png';
import Button from '@/presentation/components/elements/Button';
import { URLS } from '@/presentation/utils/urls';
import Image from 'next/image';
import { useTranslations } from 'use-intl';

export const BugBountyModal = () => {
  const t = useTranslations('Modals.BugBounty');
  const trackEvent = useTrackEvent();

  return (
    <div className="py-5 relative">
      <div className="px-6">
        <span className="mr-4">{t('title')}</span>
        <span className="inline-flex items-center bg-white py-1 rounded-full relative dark:text-gray-50 px-3 pl-3 text-sm border-gray-50">
          <span className="bg-green-500 w-[8px] h-[8px] rounded-full inline-block mr-2" />
          Live
        </span>
      </div>
      <Image
        className="my-5 h-auto w-full !relative"
        src={BugBountyGraphic}
        alt={'NFTX Immunefi Bounty'}
        width={960}
        height={502}
        placeholder="blur"
      />
      <div className="px-6">
        <Button
          href={URLS.IMMUNEFI}
          target="_blank"
          onClick={() => {
            trackEvent('bug_bounty_clicked');
          }}
        >
          <span className="text-white">{t('button')}</span>
        </Button>
      </div>
    </div>
  );
};
